import { IoReload } from "react-icons/io5";
import { MdError } from "react-icons/md";

export const ErrorState: React.FC<{ error: string; onRetry: () => void }> = ({
  error,
  onRetry,
}) => (
  <div className="flex h-full  flex-col items-center justify-center  ">
    <div className="mb-2 flex items-center gap-2">
      <MdError className="h-8 w-8" />
      <span className="text-lg">{error}</span>
    </div>
    <button
      onClick={onRetry}
      className="flex items-center justify-center  gap-4 rounded bg-brand-500 px-3 py-1 text-white transition-colors hover:bg-brand-600"
    >
      <IoReload size={15} /> Retry
    </button>
  </div>
);
